import React, { useState, useEffect } from 'react';
import { Checkbox } from 'components/shadcn/ui/checkbox';
import { useToast } from 'components/shadcn/hooks/use-toast';
import HGSpinner from 'components/HGSpinner';
import { acknowledgeUpgradeRecord } from './service';
import { useJwtToken } from 'helper';

const AcknowledgedCheckbox = ({ item }) => {
    const [checked, setChecked] = useState(null);
    const [loading, setLoading] = useState(false);
    const { toast } = useToast();
    const accessToken = useJwtToken();

    useEffect(() => {
        if (checked === null) setChecked(item.acknowledged);
    }, [item, checked]);

    const handleChange = async (e) => {
        e.stopPropagation();
        setLoading(true);
        try {
            const acknowledgeUpgradeRecordResponse =
                await acknowledgeUpgradeRecord(
                    { Thing_ID: item?.Thing_ID, UpdateID: item?.UpdateID },
                    accessToken
                );
            if (acknowledgeUpgradeRecordResponse) {
                setChecked(true);
            }
        } catch (error) {
            console.error('Error acknowledging upgrade records:', error);
            toast({
                title: 'Upgrade Progress Acknowledgement',
                description: 'Error acknowledging upgrade record.',
                variant: 'destructive',
                duration: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div onClick={(e) => e.stopPropagation()} className="pr-20 text-center">
            {loading ? (
                <HGSpinner className="w-18 h-18 p-2.75 min-h-0" />
            ) : (
                <Checkbox
                    checked={checked}
                    onChange={handleChange}
                    disabled={checked}
                    className="checked:border-gray-600 checked:bg-gray-600 checked:fill-gray-600"
                />
            )}
        </div>
    );
};

export default AcknowledgedCheckbox;
